import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { EditorialMap } from 'client/tracking/maps/editorial';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingMap as MpgTrackingMap } from 'client/tracking/maps/mpg/mpg';
import { EngineTypeQuizMap } from 'client/tracking/maps/common/engine-type-quiz';

const map = {
  display_incentive_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.DISPLAY_INCENTIVE_DETAILS
  ),
};
export const TypeBuyingGuideMap = {
  ...CommonMap,
  ...EditorialMap,
  ...MpgTrackingMap,
  ...EngineTypeQuizMap,
  ...map,
};
